import { useCallback } from "react";

/**
 * Custom hook for Google Analytics gtag tracking
 * Provides helper functions for common gtag events with built-in safety checks
 */
export default function useGtag() {
  const isGtagAvailable = () => {
    return typeof window !== "undefined" && typeof window.gtag === "function";
  };

  const trackEvent = useCallback((eventName, params = {}) => {
    if (isGtagAvailable()) {
      window.gtag("event", eventName, params);
    }
  }, []);

  const trackSignUp = useCallback((method = "Email") => {
    trackEvent("sign_up", { method });
  }, [trackEvent]);

  const trackFormStart = useCallback((formId, formName) => {
    trackEvent("form_start", { form_id: formId, form_name: formName });
  }, [trackEvent]);

  const trackFormSubmit = useCallback((formId, formName) => {
    trackEvent("form_submit", { form_id: formId, form_name: formName });
  }, [trackEvent]);

  const trackGenerateLead = useCallback((fileName) => {
    trackEvent("generate_lead", { file_name: fileName });
  }, [trackEvent]);

  const trackFileDownload = useCallback((fileName) => {
    trackEvent("file_download", { file_name: fileName });
  }, [trackEvent]);

  return {
    trackEvent,
    trackSignUp,
    trackFormStart,
    trackFormSubmit,
    trackGenerateLead,
    trackFileDownload,
  };
}

/**
 * Standalone function for use in non-component contexts (e.g., onClick handlers in JSX)
 * Use this when you can't use the hook (e.g., inside array items or non-component functions)
 */
export const trackGtagEvent = (eventName, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
};

export const trackGenerateLead = (fileName) => {
  trackGtagEvent("generate_lead", { file_name: fileName });
};
